import { render, staticRenderFns } from "./NodeHealthWidgetComponent.vue?vue&type=template&id=fdea3edc&scoped=true&"
import script from "./NodeHealthWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./NodeHealthWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NodeHealthWidgetComponent.vue?vue&type=style&index=0&id=fdea3edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea3edc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
